<template>
  <div class="notice-box" v-if="show">
    <div class="container clearfix">
      公告：<span v-html="notice.content"></span>
      <span class="notice-close" @click="close">【关闭】</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: {
        content: null,
      },
      show: false,
    };
  },
  created() {
    this.getLatestNotice();
  },
  methods: {
    getLatestNotice() {
      const me = this;
      me.$ajax({
        url: me.$url.api + "/api/operation/sys_notice/latest",
        method: "get",
      }).then((res) => {
        const data = res.data.data;
        if (data && data != null) {
          me.notice = data;
          me.checkToShow(data);
        }
      });
    },
    checkToShow(notice) {
      if (!notice) {
        return;
      }
      // warn级别每次都显示
      if (notice.level == 1) {
        this.show = true;
      } else {
        // info级别只显示首次
        const key = "notice-" + notice.id,
          value = localStorage.getItem(key);
        if (!value) {
          this.show = true;
        }
      }
    },
    close() {
      const me = this;
      me.show = false;
      localStorage.setItem("notice-" + me.notice.id, 1);
    },
  },
};
</script>

<style scoped>
.notice-box {
  position: relative;
  line-height: 30px;
  height: 30px;
  color: #473d16;
  font-size: 12px;
  background: #fffabe;
  overflow: hidden;
  padding: 0 60px;
}

.notice-box .container {
    padding: 0;
}

.notice-box a {
  color: #3597d5;
}

.notice-box a:hover {
  font-weight: bold;
  color: #3597d5;
}

.notice-box .notice-close {
  float: right;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/header/Notice.vue